import script from "./SkillsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsTable.vue?vue&type=script&setup=true&lang=js"

import "./SkillsTable.vue?vue&type=style&index=0&id=05b39a1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b39a1d"]])

export default __exports__